import * as tslib_1 from "tslib";
import { HtmlView } from '@swim/ui';
var PieceView = (function (_super) {
    tslib_1.__extends(PieceView, _super);
    function PieceView(node) {
        var _this = _super.call(this, node) || this;
        _this._proportion = 'any';
        _this._placement = 'any';
        _this._pieceMargin = 0;
        _this._pieceWidth = 0;
        _this._pieceHeight = 0;
        _this._reflowTransition = undefined;
        return _this;
    }
    PieceView.prototype.proportion = function (proportion) {
        if (proportion === undefined) {
            return this._proportion;
        }
        else {
            if (this._proportion !== proportion) {
                this._proportion = proportion;
                if (this._parentView) {
                    this._parentView.requireResize();
                }
            }
            return this;
        }
    };
    PieceView.prototype.placement = function (placement) {
        if (placement === undefined) {
            return this._placement;
        }
        else {
            if (this._placement !== placement) {
                this._placement = placement;
                if (this._parentView) {
                    this._parentView.requireResize();
                }
            }
            return this;
        }
    };
    PieceView.prototype.pieceMargin = function (pieceMargin, trans) {
        if (pieceMargin === undefined) {
            return this._pieceMargin;
        }
        else {
            this._pieceMargin = pieceMargin;
            return this;
        }
    };
    PieceView.prototype.pieceWidth = function (pieceWidth, trans) {
        if (pieceWidth === undefined) {
            return this._pieceWidth;
        }
        else {
            this._pieceWidth = pieceWidth;
            return this;
        }
    };
    PieceView.prototype.pieceHeight = function (pieceHeight, trans) {
        if (pieceHeight === undefined) {
            return this._pieceHeight;
        }
        else {
            this._pieceHeight = pieceHeight;
            return this;
        }
    };
    PieceView.prototype.reflowTransition = function (reflowTransition) {
        if (reflowTransition === undefined) {
            return this._reflowTransition || null;
        }
        else {
            this._reflowTransition = reflowTransition || undefined;
            return this;
        }
    };
    PieceView.prototype.didSetState = function (newState, oldState) {
        _super.prototype.didSetState.call(this, newState, oldState);
        var proportion = newState.get('proportion').stringValue();
        if (proportion !== undefined) {
            this.proportion(proportion);
        }
        var placement = newState.get('placement').stringValue();
        if (placement !== undefined) {
            this.placement(placement);
        }
    };
    return PieceView;
}(HtmlView));
export { PieceView };
//# sourceMappingURL=data:application/json;base64,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